import type { ShopScale } from "@/api/stores/type";

import type { StoreScale } from "./types";

/** 门店管理页权限码 */
export const STORE_PERMISSION = {
  /** 邀请门店 */
  invite: "ops:store:invite",
  /** 启停 */
  changeStatus: "ops:store:changeStatus",
  /** 删除已过期门店 */
  delete: "ops:store:delete",
} as const;

/** 列表规模筛选项（与 ShopPageQueryRequest.scale 一致） */
export const SHOP_SCALE_FILTER_OPTIONS: { value: ShopScale; label: string }[] = [
  { value: "LARGE", label: "大型" },
  { value: "MEDIUM", label: "中型" },
  { value: "SMALL", label: "小型" },
];

/** 门店规模 Tag 颜色 */
export const getStoreScaleColor = (scale: string): string => {
  if (scale === "大型") return "blue";
  if (scale === "中型") return "green";
  return "gold";
};

/** 规模展示主题（详情卡片渐变） */
export const STORE_SCALE_THEME: Record<StoreScale, { tagColor: string; gradient: string }> = {
  大型: {
    tagColor: "red",
    gradient: "bg-linear-to-br from-red-400 via-red-500 to-orange-500",
  },
  中型: {
    tagColor: "gold",
    gradient: "bg-linear-to-br from-amber-400 via-amber-500 to-orange-500",
  },
  小型: {
    tagColor: "green",
    gradient: "bg-linear-to-br from-emerald-400 via-emerald-500 to-teal-500",
  },
};
